/**
 * Buffers events in a queue and sends to telemetry.
 */
import { BUFFER_SIZE } from './LogBuffer.constants';

export class LogBuffer {
  private static _bufferQueue: Array<() => void>;
  private static _bufferSize: number;
  private static instance: LogBuffer;

  public static getInstance(): LogBuffer {
    if (!LogBuffer.instance) {
      LogBuffer.instance = new LogBuffer();
      this._initializeLogBuffer();
    }

    return LogBuffer.instance;
  }

  /***
   * Empty's the log buffer queue.
   * @param callback optional method to call after the log bufferQueue is emptied.
   */
  public static flushLogBuffer(callback?: () => {}): void {
    if (!LogBuffer.instance || !LogBuffer._bufferQueue) {
      throw new Error('[flushLogBuffer]: LogBuffer is undefined.');
    }

    LogBuffer._bufferQueue = [];

    if (callback) {
      callback();
    }
  }

  /***
   * Adds event log to the logBuffer queue.
   * @param event logged event.
   */
  public static addToLogBuffer(event: () => void): void {
    if (!LogBuffer.instance) {
      throw new Error('[addToLogBuffer]: LogBuffer is undefined.');
    }

    if (LogBuffer._bufferQueue.length === LogBuffer._bufferSize) {
      LogBuffer._bufferQueue.shift();
    }

    if (event) {
      LogBuffer._bufferQueue.push(event);
    }
  }

  /***
   * pushes the event logs to telemetry client and flushes the event log queue.
   */
  public static pushLogsToTelemetryClient(): void {
    if (!LogBuffer.instance) {
      throw new Error('[pushLogsToTelemetryClient]: LogBuffer is undefined.');
    }

    for (let event of LogBuffer._bufferQueue) {
      event();
    }

    this.flushLogBuffer();
  }

  /***
   * Return the event log queue size.
   */
  public static getLogBufferSize(): number {
    if (!LogBuffer.instance) {
      throw new Error('[getLogBufferSize]: LogBuffer is undefined.');
    }

    return LogBuffer._bufferQueue.length;
  }

  /***
   * Initializes the bufferQueue with a max size of 100.
   * The bufferQueue is flushed on call of flush method whichever happens first.
   */
  private static _initializeLogBuffer(): void {
    if (!LogBuffer._bufferQueue) {
      LogBuffer._bufferSize = BUFFER_SIZE;
      LogBuffer._bufferQueue = [];
    }
  }

  private constructor() {}
}
